// extracted by mini-css-extract-plugin
export default {"map-style-list":"switchstylecontent_map-style-list__3sBoQ","map-style-list__title":"switchstylecontent_map-style-list__title__19H10"};